var en_us = {
    values: {
        'Qualifier': 'Qualifier',
        'Lookup table for expected inspector count': 'Lookup table for expected inspector count',
        'Recommendations / Observations': 'Recommendations / Observations',
        'Critical Pendencies': 'Critical Pendencies',
        'Search Interval': 'Search Interval (minutes)',
        'Message': 'Message'
    }
};

module.exports = en_us;
